import { render } from "./PlanTable.vue?vue&type=template&id=32c35f7a&scoped=true"
import script from "./PlanTable.vue?vue&type=script&lang=js"
export * from "./PlanTable.vue?vue&type=script&lang=js"

import "./PlanTable.vue?vue&type=style&index=0&id=32c35f7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c35f7a"]])

export default __exports__